// extracted by mini-css-extract-plugin
var _1 = "WartContainer__border--L3r4P WartContainer__borderBase--cXxVY";
var _2 = "WartContainer__borderBase--cXxVY";
var _3 = "WartContainer__container--kLruw general__shadow--ifbUf ProgressTabContent__grade--VuK3A CoreGeneral__robotoSlab--X8lgW";
var _4 = "WartContainer__content--wEkf9";
var _5 = "WartContainer__main--zs99D";
var _6 = "WartContainer__openArea--VpTFJ";
var _7 = "WartContainer__singleBorder--FeXOZ WartContainer__borderBase--cXxVY";
var _8 = "WartContainer__slant--sQgCj";
var _9 = "WartContainer__wBorder--NBn18";
var _a = "WartContainer__wContent--LU8fE";
var _b = "WartContainer__wart--apIvB";
export { _1 as "border", _2 as "borderBase", _3 as "container", _4 as "content", _5 as "main", _6 as "openArea", _7 as "singleBorder", _8 as "slant", _9 as "wBorder", _a as "wContent", _b as "wart" }
